import { BasePermissionV2 } from '../dto/userGroupsDto';

export const getKeySortedPermissionObject = (unsortedObj: BasePermissionV2) => {
  const keySortedObj: BasePermissionV2 = {};
  const sortedKeys = Object.keys(unsortedObj).sort();
  sortedKeys.forEach(key => (keySortedObj[key] = unsortedObj[key]));
  return keySortedObj;
};
